"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = Header;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var logout_1 = require("../../features/thunks/logout");
var hooks_1 = require("../../store/hooks");
var breadcrumb_nav_1 = require("./breadcrumb-nav");
function MenuIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-6 w-6", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M4 6h16M4 12h16M4 18h16" }) }));
}
function LogoutIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-4 w-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" }) }));
}
function UserIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-4 w-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" }) }));
}
function Header(props) {
    var _a;
    var onMenuClick = props.onMenuClick;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.auth; }).user;
    var _b = (0, react_2.useState)(false), isMenuOpen = _b[0], setIsMenuOpen = _b[1];
    var menuRef = (0, react_2.useRef)(null);
    var handleProfileClick = function () {
        setIsMenuOpen(false);
        navigate("/account/profile");
    };
    var handleLogout = function () {
        setIsMenuOpen(false);
        dispatch((0, logout_1.logoutThunk)());
    };
    var getInitials = function (name) {
        return name
            .split(" ")
            .map(function (n) { return n[0]; })
            .join("")
            .toUpperCase()
            .slice(0, 2);
    };
    // Close menu when clicking outside
    (0, react_2.useEffect)(function () {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        }
        if (isMenuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            return function () { return document.removeEventListener("mousedown", handleClickOutside); };
        }
    }, [isMenuOpen]);
    // Close menu on escape key
    (0, react_2.useEffect)(function () {
        function handleEscape(event) {
            if (event.key === "Escape") {
                setIsMenuOpen(false);
            }
        }
        if (isMenuOpen) {
            document.addEventListener("keydown", handleEscape);
            return function () { return document.removeEventListener("keydown", handleEscape); };
        }
    }, [isMenuOpen]);
    return ((0, jsx_runtime_1.jsxs)("header", { className: "sticky top-0 z-30 flex h-16 items-center justify-between border-b border-divider bg-content1 px-4 lg:px-6", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-4", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, variant: "light", className: "lg:hidden", onPress: onMenuClick, children: (0, jsx_runtime_1.jsx)(MenuIcon, {}) }), (0, jsx_runtime_1.jsx)(breadcrumb_nav_1.BreadcrumbNav, {})] }), (0, jsx_runtime_1.jsx)("div", { className: "flex items-center gap-4", children: user && ((0, jsx_runtime_1.jsxs)("div", { className: "relative", ref: menuRef, children: [(0, jsx_runtime_1.jsxs)(react_1.Button, { variant: "light", className: "flex items-center gap-2", onPress: function () { return setIsMenuOpen(!isMenuOpen); }, children: [(0, jsx_runtime_1.jsx)(react_1.Avatar, { size: "sm", name: getInitials(user.name), className: "bg-primary text-primary-foreground" }), (0, jsx_runtime_1.jsxs)("div", { className: "hidden text-left md:block", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-sm font-medium", children: user.name }), (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-default-500", children: (_a = user.role) === null || _a === void 0 ? void 0 : _a.name })] })] }), isMenuOpen && ((0, jsx_runtime_1.jsxs)("div", { className: "absolute right-0 top-full mt-2 w-56 rounded-xl border border-default-200 bg-white py-2 shadow-lg", style: { zIndex: 9999 }, children: [(0, jsx_runtime_1.jsxs)("div", { className: "border-b border-default-100 px-4 py-3", children: [(0, jsx_runtime_1.jsx)("p", { className: "font-semibold text-foreground", children: user.name }), (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-default-500", children: user.email })] }), (0, jsx_runtime_1.jsxs)("div", { className: "py-1", children: [(0, jsx_runtime_1.jsxs)("button", { onClick: handleProfileClick, className: "flex w-full items-center gap-2 px-4 py-2 text-left text-sm text-foreground hover:bg-default-100", children: [(0, jsx_runtime_1.jsx)(UserIcon, {}), "My Account"] }), (0, jsx_runtime_1.jsxs)("button", { onClick: handleLogout, className: "flex w-full items-center gap-2 px-4 py-2 text-left text-sm text-danger hover:bg-danger-50", children: [(0, jsx_runtime_1.jsx)(LogoutIcon, {}), "Log Out"] })] })] }))] })) })] }));
}
